import React, { useContext } from 'react';
export const MobileContext = React.createContext(false);
MobileContext.displayName = 'MobileContext';
export const BaseURLContext = React.createContext('');
BaseURLContext.displayName = 'BaseURLContext';
export const useBaseURL = () => {
	return useContext(BaseURLContext);
};